export default __webpack_public_path__ + "static/h05-311ec0a5423408daaa3a628e3ddef8de.png";